import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalRelationsForContent: ExperimentalQueries['experimentalRelationsForContent'] =
	(_, { relationName, sourceType, targetKey, targetStatus }, { network }) => {
		if (!relationName) return Promise.reject(new Error('relationName is missing'));
		if (!sourceType) return Promise.reject(new Error('sourceType is missing'));
		if (!targetKey) return Promise.reject(new Error('targetKey is missing'));
		if (!targetStatus) return Promise.reject(new Error('targetStatus is missing'));

		return fetchJSON(
			network,
			`/wiki/rest/api/relation/${relationName}/to/content/${targetKey}/from/${sourceType}/?targetStatus=${targetStatus}&expand=source,relationData`,
			{
				method: 'GET',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		).catch((reason) => {
			const { response } = reason;
			if (response?.status === 403) {
				throwErrorWithResponse(
					Error('User does not have permission to view the relationship'),
					response,
				);
			} else if (response?.status === 404) {
				throwErrorWithResponse(Error('Target entity does not exist'), response);
			} else {
				throwErrorWithResponse(Error('Unknown error'), response);
			}
		});
	};
